export const updateSchemaPreview = (fields) => {
  const setFileObject = () => {
    const fileExample = {
      src: 'https://link.to/image',
      path: 'Image/image.jpg',
      mimeType: 'image/jpeg',
      totalBytes: 333942,
      lastModifiedTime: 'Wed, 01 Apr 2020 15:19:48 GMT',
    };

    return fileExample;
  };

  const toExample = (fields) =>
    fields.reduce((acc, v) => {
      if (v.type === 'CURRENCY' && v.singleValue) {
        acc[v.name] = '12.24';
        acc[v.name + 'Currency'] = 'USD';

        return acc;
      }
      if (v.type === 'FILE' && v.singleValue) {
        const name = v.name;
        acc[name] = setFileObject(name);

        return acc;
      }
      if (!v.deprecated) {
        let exampleValue = (() => {
          switch (v.type) {
            case 'OBJECT':
              return toExample(v.fields || []);
            case 'BOOLEAN':
              return true;
            case 'INTEGER':
              return 1;
            case 'CURRENCY': {
              const price = v.name;
              const priceCurrency = `${v.name}Currency`;
              const currencyExample = { [price]: 12.25, [priceCurrency]: 'USD' };

              return currencyExample;
            }
            case 'NUMBER':
              return 3.14;
            case 'DATE':
              return '2015-02-04';
            case 'DATETIME':
              return '2016-04-03T12:12:00Z';
            case 'IMAGE':
              return 'https://link.to/image';
            case 'LINK':
              return 'https://link.to/something';
            case 'FILE': {
              const name = v.name;
              const exampleFile = setFileObject(name);

              return exampleFile;
            }
            default:
              return 'string';
          }
        })();

        if (!v.singleValue) {
          exampleValue = [exampleValue];
        }
        acc[v.name] = exampleValue;
        return acc;
      } else {
        return acc;
      }
    }, {});
  const obj = toExample(fields);
  return obj;
};
